import React, { useState, useEffect, useRef } from "react";
import api from "@/api";

export default function CropModal({ open, onClose, crop, onSaved }) {
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [saving, setSaving] = useState(false);
  const modalRef = useRef(null);

  useEffect(() => {
    if (crop) {
      setName(crop.name || "");
      setDescription(crop.description || "");
    } else {
      setName("");
      setDescription("");
    }
  }, [crop, open]);

  // Dismiss on Esc key only (click-away removed)
  useEffect(() => {
    if (!open) return;
    function handleKey(e) {
      if (e.key === "Escape") onClose();
    }
    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [open, onClose]);

  function handleSubmit(e) {
    e.preventDefault();
    setSaving(true);
    const payload = { name, description };
    const data = crop ? { ...payload, id: crop.id } : payload;
    api
      .post("/masterdata/crops/store", data)
      .then(() => {
        setSaving(false);
        onSaved();
      })
      .catch(() => setSaving(false));
  }

  if (!open) return null;
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/30">
      <div
        ref={modalRef}
        className="bg-white dark:bg-gray-900 rounded-lg shadow-lg p-6 w-full max-w-md relative"
      >
        <button
          className="absolute top-2 right-2 text-gray-400 hover:text-gray-700 dark:hover:text-gray-200"
          onClick={onClose}
          aria-label="Close"
        >
          ×
        </button>
        <h2 className="text-xl font-bold mb-4">
          {crop ? "Edit Crop" : "Add Crop"}
        </h2>
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">Name</label>
            <input
              className="border rounded px-3 py-2 w-full dark:bg-gray-800 dark:border-gray-700"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              autoFocus
            />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">
              Description
            </label>
            <input
              className="border rounded px-3 py-2 w-full dark:bg-gray-800 dark:border-gray-700"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              required
            />
          </div>
          <button
            type="submit"
            className="bg-emerald-600 hover:bg-emerald-700 text-white font-semibold px-4 py-2 rounded shadow disabled:opacity-50"
            disabled={saving}
          >
            {saving ? "Saving..." : crop ? "Save Changes" : "Add Crop"}
          </button>
        </form>
      </div>
    </div>
  );
}
